// extracted by mini-css-extract-plugin
export default {"commentHeader":"_2f2XI","search":"_1kBSp","commentTime":"n9Cw-","withMoreButton":"_6m-n8","moreButton":"_31ZLQ","isBestAnswer":"sz19c"};